// extracted by mini-css-extract-plugin
export var statItem = "_jp-1";
export var statsRow = "_jp-0";